import { render, staticRenderFns } from "./Punschfest2025.vue?vue&type=template&id=0d618cc2&scoped=true"
import script from "./Punschfest2025.vue?vue&type=script&lang=js"
export * from "./Punschfest2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d618cc2",
  null
  
)

export default component.exports